const ITEMS = [
  "CALORIES IN = ENERGY OUT",
  "CAPITAL IN = WEALTH GAIN",
  "DUAL METRIC REVOLUTION",
  "FITNANCE.APP",
];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="mx-10 font-mono text-xs tracking-[0.35em] text-neutral-500">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-500/60" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="-rotate-1 border-y border-white/5 bg-[#0A0C10] py-6"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
    </section>
  );
}
